import { Controller } from '@hotwired/stimulus';

// A fixed corner button never sits on a field (docs/DESIGN.md § chat / fab /
// timeline): kio's radio (`.fab`, its round button the `button` target) and
// jane's help bubble (the element itself). On a phone it fades out, and stops
// taking taps, while a visible field is under it: `data-covers`, which fire.css
// draws. It looks again on every scroll, resize, layout change and focus move;
// one held open (focus inside) stays. A field in a popover is its own card's.
// A field is the box she sees (BOX), not the bare input inside it.
const FIELDS = 'input:not([type=hidden]):not([type=submit]):not([type=checkbox]):not([type=radio]), select, textarea';
const BOX = '.input, .select, .textarea';
const PHONE = '(max-width: 639px)';

export default class extends Controller {
  static targets = ['button'];

  connect() {
    this.look = () => (this.frame ||= requestAnimationFrame(() => this.check()));
    this.ro = new ResizeObserver(this.look);
    this.ro.observe(document.body);
    addEventListener('scroll', this.look, { passive: true });
    addEventListener('resize', this.look);
    this.element.addEventListener('focusin', this.look);
    this.element.addEventListener('focusout', this.look);
    this.look();
  }

  disconnect() {
    this.ro.disconnect();
    removeEventListener('scroll', this.look);
    removeEventListener('resize', this.look);
    this.element.removeEventListener('focusin', this.look);
    this.element.removeEventListener('focusout', this.look);
    cancelAnimationFrame(this.frame);
  }

  check() {
    this.frame = null;
    const a = (this.hasButtonTarget ? this.buttonTarget : this.element).getBoundingClientRect();
    const under =
      matchMedia(PHONE).matches &&
      !this.element.matches(':focus-within') &&
      [...document.querySelectorAll(FIELDS)].some((field) => {
        const b = (field.closest(BOX) ?? field).getBoundingClientRect();
        return (
          b.width > 0 &&
          !field.closest('[popover]') &&
          a.left < b.right &&
          a.right > b.left &&
          a.top < b.bottom &&
          a.bottom > b.top
        );
      });
    this.element.toggleAttribute('data-covers', under);
  }
}
